import { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
import { outbox } from '@/lib/outbox';

/**
 * Yellow banner shown above the message list when there are queued
 * offline messages waiting for connectivity. Polls every 2s — small
 * cost vs. the wiring needed to push from the outbox API.
 */
export default function OutboxBanner() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const tick = async () => {
      try {
        const c = await outbox.count();
        if (!cancelled) setCount(c);
      } catch { /* ignore */ }
    };
    tick();
    const id = window.setInterval(tick, 2000);
    return () => { cancelled = true; window.clearInterval(id); };
  }, []);

  if (count === 0) return null;

  return (
    <div className="px-3 py-1.5 bg-amber-700/80 text-white text-xs flex items-center gap-2 border-b border-amber-900">
      <Clock size={12} />
      В очереди: {count} — отправим как появится сеть
    </div>
  );
}
